/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps, IconSize} from '../../types/types';
import useIconDLS from './../useIconDLS';

/*
 * Defines the Design Language System (DLS) Asset Airplane Icon component.
 */
export const AssetAirplaneIcon = (props: IconProps) => {
  const {color, size = IconSize.large} = props;
  const {iconSize, iconColor} = useIconDLS({color, size});
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none'>
      <path d="M19.5654 2C19.9832 2.00679 20.3823 2.13907 20.6523 2.40625C20.9204 2.67628 21.0517 3.07458 21.0586 3.49219C21.0712 4.26748 20.5926 5.20128 19.8145 5.97949C18.6681 7.25323 17.383 8.5052 16.084 9.71094L17.999 19.2852C18.0432 19.5061 17.9338 19.7291 17.7324 19.8301L17.0283 20.1826C16.7815 20.3059 16.4809 20.2057 16.3574 19.959L12.8506 12.9443L7.89844 17.1523L8.24512 19.5654C8.26723 19.7209 8.21444 19.8781 8.10352 19.9893L7.54688 20.5479L5.5 17.5L2.5 15.5L3.05957 14.9395C3.16938 14.8294 3.32438 14.7767 3.47852 14.7969L5.93945 15.1182L10.1143 10.208L3.09961 6.70117C2.85281 6.57769 2.75274 6.27716 2.87598 6.03027L3.22852 5.32617C3.32946 5.12478 3.5525 5.01538 3.77344 5.05957L13.3477 6.97461C14.5535 5.6756 15.8054 4.39061 17.0791 3.24414C17.8572 2.46611 18.7902 1.98757 19.5654 2Z" fill={iconColor}/>
    </svg>
  );
};

export default AssetAirplaneIcon;
